module.exports = __webpack_public_path__ + "img/bg4.f5e4b2f0.png";